import { Play, Instagram, Youtube, ExternalLink } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { useEffect, useState } from "react";
import { Eye } from "lucide-react";


// const youtubeVideos = [
//   {
//     id: 1,
//     title: "Virtual Tour - Skyline Heights Project",
//     thumbnail: "/api/placeholder/400/300",
//     duration: "3:45",
//     views: "12K views",
//     url: "https://youtube.com/shorts/1X__va1p2nI?si=_5HliEnR7l9Vf8Kp"
//   },
//   {
//     id: 2,
//     title: "Customer Testimonial - Happy Homeowners",
//     thumbnail: "/api/placeholder/400/300",
//     duration: "2:30",
//     views: "8.5K views",
//     url: "https://youtube.com/shorts/ryIFOU4sZbw?si=gxyG9RmjrdOLvyRd"
//   },
//   {
//     id: 3,
//     title: "Construction Progress - Vista Residency",
//     thumbnail: "/api/placeholder/400/300",
//     duration: "4:12",
//     views: "15K views",
//     url: "https://youtube.com/watch?v=example3"
//   }
// ];

// const instagramPosts = [
//   {
//     id: 1,
//     image: "/api/placeholder/400/400",
//     caption: "Another beautiful home delivered! 🏠✨ #SkylineProperties #DreamHome",
//     likes: "234 likes",
//     url: "https://instagram.com/p/example1"
//   },
//   {
//     id: 2,
//     image: "/api/placeholder/400/400",
//     caption: "Construction milestone achieved at Vista Residency 🔨 #Construction #Progress",
//     likes: "189 likes",
//     url: "https://instagram.com/p/example2"
//   },
//   {
//     id: 3,
//     image: "/api/placeholder/400/400",
//     caption: "Happy families, happy homes! Welcome to your new address 🎉 #NewHome #Celebration",
//     likes: "321 likes",
//     url: "https://instagram.com/p/example3"
//   }
// ];

const getYouTubeThumbnail = (url) => {
  let videoId = "";

  if (url.includes("/shorts/")) {
    // Example: https://youtube.com/shorts/1X__va1p2nI
    videoId = url.split("/shorts/")[1].split("?")[0];
  } else if (url.includes("watch?v=")) {
    // Example: https://youtube.com/watch?v=abcd1234
    videoId = url.split("watch?v=")[1].split("&")[0];
  }

  // Return the standard YouTube thumbnail
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};


const SocialMediaSection = () => {
  const [youtubeVideos, setYoutubeVideos] = useState([]);

 // Helper: Convert ISO8601 duration to seconds
const isoToSeconds = (iso) => {
  const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
  const match = iso.match(regex);
  const hours = parseInt(match[1] || 0);
  const minutes = parseInt(match[2] || 0);
  const seconds = parseInt(match[3] || 0);
  return hours * 3600 + minutes * 60 + seconds;
};

// Helper: Convert seconds to mm:ss format
const secondsToMMSS = (sec) => {
  const m = Math.floor(sec / 60).toString().padStart(2, "0");
  const s = Math.floor(sec % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
};

const fetchLatestShorts = async (channelId, maxResults = 16) => {
  const apiKey = 'AIzaSyBXdjTPr86iOd9vzUEwSOFO0aDqr6JvPQg';

  // Get recent videos
  const res = await fetch(
    `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&maxResults=10&order=date&type=video&key=${apiKey}`
  );
  const data = await res.json();

  if (!data.items) return [];

  const videoIds = data.items.map((item) => item.id.videoId).join(",");

  // Get video details
  const detailsRes = await fetch(
    `https://www.googleapis.com/youtube/v3/videos?part=contentDetails,statistics,snippet&id=${videoIds}&key=${apiKey}`
  );
  const detailsData = await detailsRes.json();

  // Filter Shorts and take last 3
  const shorts = detailsData.items
    .filter((item) => isoToSeconds(item.contentDetails.duration) < 60)
    .slice(0, maxResults)
    .map((item) => ({
      id: item.id,
      title: item.snippet.title,
      thumbnail: item.snippet.thumbnails.high.url,
      duration: secondsToMMSS(isoToSeconds(item.contentDetails.duration)),
      views: item.statistics.viewCount,
      url: `https://youtube.com/watch?v=${item.id}`,
      isShort: true,
    }));

  return shorts;
};


// Helper: Convert ISO8601 duration to seconds
const parseISO8601Duration = iso => {
  const match = iso.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  const hours = parseInt(match[1]) || 0;
  const minutes = parseInt(match[2]) || 0;
  const seconds = parseInt(match[3]) || 0;
  return hours * 3600 + minutes * 60 + seconds;
};


useEffect(() => {
  fetchLatestShorts("UCw_wLdHnL27K2vZzJXaRZoQ")
    .then(setYoutubeVideos)
    .catch(err => console.error(err));
}, []);



  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-fade-up">
          <h2 className="font-display-bold text-4xl md:text-5xl text-primary mb-6">
            Follow Our Journey
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Stay connected with us on social media for the latest updates, virtual tours, and customer stories
          </p>
        </div>

        {/* YouTube Section */}
        <div className="mb-16">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 bg-red-500 rounded-full">
                <Youtube className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="font-display-bold text-2xl text-primary">YouTube Channel</h3>
                <p className="text-muted-foreground">Virtual tours and property showcases</p>
              </div>
            </div>
           <Button
  variant="outline"
  size="sm"
  className="hidden md:flex bg-gradient-to-r from-red-500 via-yellow-400 to-pink-500 text-white hover:from-pink-500 hover:via-red-400 hover:to-yellow-500 border-0 shadow-lg transition-all duration-300"
  onClick={() => window.open('https://www.youtube.com/@Solapur_property_', '_blank')}
>
  <ExternalLink className="mr-2 h-4 w-4 text-white" />
  Visit Channel
</Button>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
  {youtubeVideos?.length > 0 && youtubeVideos.map((video, index) => (
    <Card
      key={video.id}
      className="luxury-card group cursor-pointer flex flex-col mb-6 md:mb-0" // add mb-6 for mobile
      onClick={() => window.open(video.url, "_blank")}
      style={{ animationDelay: `${index * 0.2}s` }}
    >
                <div className="relative overflow-hidden">
                  {/* <img
  src={getYouTubeThumbnail(video.url)}
                    alt={video.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  /> */}

                  {video.url.includes("/shorts/") && (
    <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
      SHORT
    </div>
  )}


                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
                      <Play className="h-8 w-8 text-white ml-1" fill="currentColor" />
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-sm">
                    {video.duration}
                  </div>
                </div>
              <Card
  key={video.id}
  className="luxury-card group cursor-pointer flex flex-col"
>
  <div className="relative overflow-hidden">
    <img
      src={getYouTubeThumbnail(video.url)}
      alt={video.title}
      className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
    />

    {video.isShort && (
      <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
        SHORT
      </div>
    )}

    <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
        <Play className="h-8 w-8 text-white ml-1" fill="currentColor" />
      </div>
    </div>

    <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-sm">
      {video.duration}
    </div>
  </div>

  <CardContent className="p-4 flex flex-col flex-1 justify-between">
    <div>
      <h4 className="font-medium text-primary mb-2 line-clamp-2 group-hover:text-luxury transition-colors">
        {video.title}
      </h4>
    <p className="flex items-center text-sm font-medium mb-2 text-green-600 bg-green-100/50 px-2 py-1 rounded-full w-max">
  <Eye className="h-4 w-4 mr-1 text-green-700" />
  {video.views.toLocaleString()} views
</p>

    </div>

    <Button
      variant="outline"
      size="sm"
      onClick={(e) => {
        e.stopPropagation(); // prevent outer card onClick
        window.open(video.url, "_blank");
      }}
      className="mt-2 w-full"
    >
      <Play className="mr-2 h-4 w-4" /> Watch Video
    </Button>
  </CardContent>
</Card>

              </Card>
            ))}
          </div>
        </div>

        {/* Instagram Section */}
        {/* <div>
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full">
                <Instagram className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="font-display-bold text-2xl text-primary">Instagram</h3>
                <p className="text-muted-foreground">Behind the scenes and daily updates</p>
              </div>
            </div>
            <Button variant="outline" size="sm" className="hidden md:flex">
              <ExternalLink className="mr-2 h-4 w-4" />
              Follow Us
            </Button>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {instagramPosts.map((post, index) => (
              <Card 
                key={post.id}
                className="luxury-card group cursor-pointer"
                onClick={() => window.open(post.url, '_blank')}
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={post.image}
                    alt="Instagram post"
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 right-4">
                    <Instagram className="h-6 w-6 text-white drop-shadow-lg" />
                  </div>
                </div>
                <CardContent className="p-4">
                  <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                    {post.caption}
                  </p>
                  <p className="text-xs text-muted-foreground font-medium">{post.likes}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default SocialMediaSection;